export const SplitOrdersType = {
	not_split: 0,
	split_by_ref: 1,
	split_by_line: 2,
}